<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :items="importedDocuments"
      :items-per-page="10"
      :footer-props="{ 'items-per-page-text': 'Số Hồ Sơ một trang' }"
      v-bind="this.$attrs"
      disable-sort
    >
      <template v-slot:[`item.studentLearningMethods`]="{ item }">
        <LeadInfoDisplay :data="item.studentLearningMethods" :type="CONFIG_KEYS.STUDENT_LEARNING_METHOD" />
      </template>
      <template v-slot:[`item.studentProducts`]="{ item }">
        <LeadInfoDisplay :data="item.studentProducts" :type="CONFIG_KEYS.STUDENT_PRODUCT" />
      </template>
      <template v-slot:[`item.studentDepartments`]="{ item }">
        <LeadInfoDisplay :data="item.studentDepartments" :type="CONFIG_KEYS.STUDENT_DEPARTMENT" />
      </template>
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IMPORT_PREVIEW_TABLE_HEADER, CONFIG_KEYS } from './helpers'
import LeadInfoDisplay from './LeadInfoDisplay.vue'

export default {
  components: { LeadInfoDisplay },
  computed: {
    ...mapGetters({ importedDocuments: 'lead/importedItems' }),
    headers() {
      return IMPORT_PREVIEW_TABLE_HEADER
    },
  },
  data: () => ({ CONFIG_KEYS }),
}
</script>
